import * as React from 'react';
import s from './category-header.scss';
import type { ISubCategoriesSelectorProps } from '../sub-categories-selector';
import {
  dtoToSubCategoriesSelectorProps,
  SubCategoriesSelector,
} from '../sub-categories-selector';
import type { GetWebSolutionsByTagsResponse } from '@wix/ambassador-marketplace/types';
import { Box, Heading, Text } from '@wix/design-system';
import { BackButton } from '../../back-button';
import { composer } from '../../../component-decorators/composer';

export interface ICategoryHeaderProps {
  name: string;
  slug?: string;
  description: string;
  subCategoriesSelectorProps: ISubCategoriesSelectorProps;
  shouldShowBackButton?: boolean;
}

export const dtoToCategoryHeaderProps = (
  res: GetWebSolutionsByTagsResponse,
): ICategoryHeaderProps => {
  const name = res?.tagsAndSubCategories?.[0].tag?.name;
  const slug = res?.tagsAndSubCategories?.[0].tag?.slug;
  const description = res?.tagsAndSubCategories?.[0].tag?.description;
  const subCategoriesSelectorProps = dtoToSubCategoriesSelectorProps(res);
  return {
    slug,
    name,
    description,
    subCategoriesSelectorProps,
  };
};

export const CategoryHeader = composer().compose(
  ({
    name,
    description,
    slug,
    subCategoriesSelectorProps,
    shouldShowBackButton,
  }: ICategoryHeaderProps) => (
    <Box
      dataHook="category-header"
      paddingBottom="42px"
      textAlign="left"
      width="100%"
      paddingTop={shouldShowBackButton ? '24px' : '36px'}
      direction="vertical"
    >
      {shouldShowBackButton && <BackButton skinColor="light" />}
      <Heading
        className={s.categoryHeaderName}
        appearance="H1"
        light={true}
        dataHook="category-header-name"
      >
        {name}
      </Heading>
      <Text
        className={s.categoryHeaderDescription}
        light
        tagName="p"
        dataHook="category-header-description"
      >
        {description}
      </Text>
      <SubCategoriesSelector
        {...subCategoriesSelectorProps}
        categorySlug={slug}
      />
    </Box>
  ),
);
